// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca, catálogo e o
// carregador das telas. Outro módulo usa a `public.ts` (que não alcança as telas: o `fund` importa a
// porta F0 e as telas importam o `fund`, então a `public.ts` fica sem o carregador para não fechar ciclo).
export { loadBatchAssignmentMessages } from './batch-assignment.catalog';
export { batchAssignmentDetailScreen, batchAssignmentListScreen, batchAssignmentNewScreen } from './batch-assignment.screen';
export {
  BATCH_ASSIGNMENT_LIST_PATH,
  batchAssignmentDetailSearch,
  batchAssignmentListSearch,
  batchAssignmentNewSearch,
  LEGACY_TAB_SEGMENTS,
  type BatchAssignmentTab,
} from './batch-assignment.search';

/** Cada tela no próprio chunk (R1 da !11138): a lista não carrega a barra do detalhe. */
export const loadBatchAssignmentListScreen = () => import('./screens/batch-assignment-list-screen');
export const loadBatchAssignmentNewScreen = () => import('./screens/batch-assignment-new-screen');
export const loadBatchAssignmentDetailScreen = () => import('./screens/batch-assignment-detail-screen');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadBatchAssignmentGuides = () => import('./batch-assignment.guide');
